import { render, staticRenderFns } from "./FollowUpStatsCard.vue?vue&type=template&id=59032ba5&"
import script from "./FollowUpStatsCard.vue?vue&type=script&lang=js&"
export * from "./FollowUpStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports